import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { CustomGreenButton } from "../Button/CustomButton";
import { SwitchButton } from "../Button/SwitchButton";
import Iconify from "../Dashboard/Iconify";
import { StyledDivider } from "../Divider/StyledDivider";
import Asynchronous from "./AutoComplete";
import { continueButtonStyle } from "./dialogStyles/DialogStyles";
import LgaAsynchronous from "./lgaAutocomplete";
import { useSelector } from "react-redux";

const getBusinessState = state => state.businessReducer

export const customHelperText = {
  fontSize: "12px",
  fontStyle: "italic",
  textTransform: "initial",
};
const FormTwo = ({
  activeStep,
  handleSubmit,
  handleBack,
  checked,
  handleChange,
  steps,
  handleBusinessForm,
  formValues,
  updateValue,
  updateLgaValue,
  stateHandler,
  lgaHandler,
  loadingButton,
  values,
  lgaValues,
  formStates,
  handleBlurEmail,
  handleBlurPhoneNumber
}) => {
  const { businessIsCreating } = useSelector(getBusinessState);

  return (
    <React.Fragment>
      <Box p="20px 10px">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={{ mt: 2, mb: 1 }}>
              Fill in the Business Details
            </Typography>
          </Grid>
          <br />
          <br />
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="businessName"
              >
                <Typography sx={{ fontSize: "14px" }}>Business Name</Typography>
              </label>
              <TextField
                size="small"
                name="businessName"
                id="businessname"
                variant="outlined"
                value={formValues.businessFormValues.businessName}
                error={formStates.businessNameError}
                helperText={formStates.businessNameErrorMsg}
                inputProps={{
                  spellCheck: true,
                  lang: "English",
                }}
                onChange={handleBusinessForm}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="email"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Email Address{" "}
                  <span style={customHelperText}>
                    (This should be a business email e.g @company.com)
                  </span>
                </Typography>
              </label>
              <OutlinedInput
                name="email"
                id="outlined-adornment-email"
                size="small"
                endAdornment={<InputAdornment position="end">@</InputAdornment>}
                aria-describedby="outlined-email-helper-text"
                inputProps={{
                  "aria-label": "email",
                }}
                onChange={handleBusinessForm}
                onBlur={handleBlurEmail}
                value={formValues.businessFormValues.email}
                error={formStates.emailAddressError}
              />
              <FormHelperText error id="accountId-error">
                {formStates.emailAddressErrorMsg}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="phonenumber"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Phone Number <span style={customHelperText}>(Business)</span>
                </Typography>
              </label>
              <TextField
                 type="number"
                name="phoneNumber"
                size="small"
                id="phonenumber"
                variant="outlined"
                InputProps={{
                  spellCheck: true,
                  lang: "English",
                  startAdornment: <InputAdornment position="start">+234</InputAdornment>,
                }}
                onChange={handleBusinessForm}
                value={formValues.businessFormValues.phoneNumber}
                error={formStates.phoneNumberError}
                helperText={formStates.phoneNumberErrorMsg}
                onBlur={handleBlurPhoneNumber}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="totalnumofyouths"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Total Number of Youths Trained
                </Typography>
              </label>
              <TextField
                type="number"
                name="staffStrength"
                size="small"
                id="totalnumofyouths"
                variant="outlined"
                inputProps={{
                  spellCheck: true,
                  lang: "English",
                }}
                onChange={handleBusinessForm}
                value={formValues.businessFormValues.staffStrength}
                error={formStates.staffStrengthError}
                helperText={formStates.staffStrengthErrorMsg}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="sourceoffunds"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Source of Funds
                </Typography>
              </label>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="sourceOfFund"
                value={formValues.businessFormValues.sourceOfFund}
                onChange={(e) => {
                  handleBusinessForm(e);
                }}
              >
                <FormControlLabel value={0} control={<Radio />} label="Loan" />
                <FormControlLabel value={1} control={<Radio />} label="Grant" />
                <FormControlLabel value={2} control={<Radio />} label="Personal" />
              </RadioGroup>
              {/*   <TextField
                type="number"
                name="sourceOfFund"
                size="small"
                id="sourceoffunds"
                variant="outlined"
                inputProps={{
                  spellCheck: true,
                  lang: "English", inputMode: 'numeric', pattern: '[0-9]*'
                }}
                onChange={(e)=>{
                  handleBusinessForm(e)
                }}
                value={(formValues.businessFormValues.sourceOfFund)}


              /> */}
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="currentstatus"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Current Status of Business
                </Typography>
              </label>
              <Stack direction="row" spacing={1} alignItems="center">
                <SwitchButton
                  defaultChecked
                  inputProps={{ "aria-label": "ant design" }}
                  name="isActive"
                  checked={formValues.businessFormValues.isActive}
                  onChange={handleBusinessForm}
                />
                <Typography
                  style={{
                    color: formValues.businessFormValues.isActive
                      ? "#016c34"
                      : "#bfbfbf",
                  }}
                >
                  {formValues.businessFormValues.isActive
                    ? "Active"
                    : "Inactive"}
                </Typography>
              </Stack>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box mb={1} mt={2}>
              <StyledDivider textAlign="left">
                <Typography variant="subtitle2" sx={{ color: "#949494" }}>
                  Business Address
                </Typography>
              </StyledDivider>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="streetaddress"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  Street Address{" "}
                  <span style={customHelperText}>(Business Location)</span>
                </Typography>
              </label>
              <TextField
                name="streetAddress"
                size="small"
                id="streetaddress"
                variant="outlined"
                inputProps={{
                  spellCheck: true,
                  lang: "English",
                }}
                onChange={handleBusinessForm}
                value={formValues.businessFormValues.streetAddress}
                error={formStates.streetAddressError}
                helperText={formStates.streetAddressErrorMsg}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="state"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  {" "}
                  State{" "}
                  <span style={customHelperText}>(Business Location)</span>
                </Typography>
              </label>
              <Asynchronous
                values={values}
                updateValue={updateValue}
                stateHandler={stateHandler}
                formStates={formStates}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="state"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  {" "}
                  LGA{" "}
                  <span style={customHelperText}>(Business Location)</span>
                </Typography>
              </label>
              <LgaAsynchronous
                values={values}
                lgaValues={lgaValues}
                updateLgaValue={updateLgaValue}
                lgaHandler={lgaHandler}
                formStates={formStates}
              />
            </FormControl>
          </Grid>
          {/*  <Grid item xs={6}>
            <FormControl fullWidth variant="outlined">
              <label
                style={{
                  marginBottom: "10px",
                  fontFamily: Typography.secondaryFont,
                }}
                htmlFor="lga"
              >
                <Typography sx={{ fontSize: "14px" }}>
                  {" "}
                  LGA  <span style={customHelperText}>(Business Location)</span>
                </Typography>
              </label>
              <Asynchronous />
            </FormControl>
          </Grid> */}
        </Grid>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1, textTransform: "capitalize" }}
        >
          Back
        </Button>
        <Box sx={{ flex: "1 1 auto" }} />

        <CustomGreenButton onClick={handleSubmit} loading={businessIsCreating}>
          {activeStep === steps.length - 1 ? (
            <span
              style={{
                padding: "2px 18px",
              }}
            >
              Save & Submit
            </span>
          ) : (
            <span style={continueButtonStyle}>
              Continue <Iconify icon="material-symbols:arrow-forward-rounded" />
            </span>
          )}
        </CustomGreenButton>
      </Box>
    </React.Fragment>
  );
};

export default FormTwo;
